import PropTypes from 'prop-types';
import React, { useState } from 'react';
import ExpandButton from '../../buttons/expandButton/ExpandButton';
import style from './ExpandingTItleWrapper.module.css';

function ExpandingTitleWrapper({ children, title, list, fixSnakeCase }) {
  let parsedList;
  if (fixSnakeCase) {
    parsedList = list.map((tactic) => {
      const arr = tactic.toLowerCase().split('_');
      const capitalized = arr.map((word) => {
        return word[0].toUpperCase() + word.slice(1);
      });
      return capitalized.join(' ');
    });
  } else {
    parsedList = list;
  }
  const [expanded, setExpanded] = useState(false);
  return (
    <div className={style.outerWrapper}>
      <p className={style.topbar}>
        <ExpandButton
          expanded={expanded}
          handleClick={() => setExpanded((prev) => !prev)}
          direction="right"
          stroke={3}
          color="grey"
          display="inline-block"
          margin="0 5px 5px 0"
          size={10}
        />
        <span className={style.title}>{title}: </span>
        <span className={style.list}>{parsedList.join(', ')}</span>
      </p>
      {expanded && children}
    </div>
  );
}

ExpandingTitleWrapper.propTypes = {
  children: PropTypes.any,
  fixSnakeCase: PropTypes.any,
  list: PropTypes.shape({
    map: PropTypes.func,
  }),
  title: PropTypes.any,
};

export default ExpandingTitleWrapper;
